// import { URLs } from '@common/api';
import { getData, URLs } from '@common/api';
import * as ImageAndText from '@common/models/ImageAndText';
import { Context as ContextInterface } from '@common/utils/constants';
import { call, ForkEffect, put, select, takeEvery } from 'redux-saga/effects';

import { fetchImageAndTextFailure, fetchImageAndTextRequest, fetchImageAndTextSuccess } from './slice';

export function* fetchImageAndTextSaga({ payload }: Record<string, string>): Generator<unknown> {
  try {
    const context: ContextInterface = yield select((store) => {
      return store.context.context;
    });
    const merchantID = context.MERCHANT_ACCOUNT_ID;
    const data = yield call(() =>
      getData({
        url: URLs.GET_IMAGE_AND_TEXT_LAYOUT.replace('{id}', payload).replace('{userId}', merchantID.toString()),
      }),
    );
    const { id, layout } = data?.data;
    const layoutName = layout?.name || 'ImageText2';
    const result = ImageAndText.processResponse(data.data, layoutName);
    yield put(fetchImageAndTextSuccess({ id: id, layout: layout, result }));
  } catch (e) {
    // console.log('ERROR', e);
    yield put(fetchImageAndTextFailure('Request failed with: ' + e));
  }
}

export default function* heroBannerSagas(): Generator<ForkEffect<never>, void, unknown> {
  yield takeEvery(fetchImageAndTextRequest.type, fetchImageAndTextSaga);
}
